module.exports = __webpack_public_path__ + "static/media/arrow-right.f854cf7c.png";